import { FeatureFlagName, FeatureFlags } from 'lib-shared-feature-flags';

import { useAppSelector } from 'utils/redux/useAppSelector';

import { hasFeature } from './hasFeature';

/** @deprecated Use `useFeatureFlag` instead. */
export const useHasFeature = <TFeatureFlagName extends FeatureFlagName>(
  name: TFeatureFlagName,
): FeatureFlags[TFeatureFlagName] => {
  return useAppSelector((state) => hasFeature(state, name));
};
